var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.subtitle)?_c('div',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }